import { getTranslation } from "helpers/common";

export const TYPE_OPTIONS = [
  { value: "Tulp", label: getTranslation("TYPE_TULIP") },
  { value: "Lelie", label: getTranslation("TYPE_LILIES") },
  { value: "BijzBolgewassen", label: getTranslation("TYPE_BULB") },
  { value: "Algemeen", label: getTranslation("TYPE_GENERAL") }
];

export const STATUS_OPTIONS = [
  { value: "published", label: getTranslation("PUBLISHED") },
  { value: "not_published", label: getTranslation("NOT_PUBLISHED") }
];
